import React from "react";

import styles from './Navigation.module.css';

import {NavLink} from 'react-router-dom';
import { useSelector } from 'react-redux';

import * as routeConstants from '../../constants/routeConstants';

const IS_DEV = process.env.REACT_APP_IS_DEV === 'true';

const Navigation = () => {

    const {isLoggedIn} = useSelector(state => state.auth);

    const getNavLinkClass = (navData) => {
        return navData.isActive ? styles.active : "";
    }

    return (
        <nav className={styles.menu}>
            <ul>
                <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_DEFAULT}>Home</NavLink></li>
                {IS_DEV && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_USERS}>Users</NavLink></li>}
                {IS_DEV && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILLS}>Skills</NavLink></li>}
                {IS_DEV && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_QUEUES}>Queues</NavLink></li>}
                {isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILL_LEVELS}>Skill levels</NavLink></li>}
                {isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_QUEUE_ACTIVATION}>Queue activation</NavLink></li>}
                {isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_QUEUE_MEMBERS}>Queue members</NavLink></li>}
                {isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILL_GROUPS}>Skill Groups</NavLink></li>}
            </ul>
        </nav>
    )
}


export default Navigation;